import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get district
export const getDistrict = createAsyncThunk("district/getDistrict", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getDistrict({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all district
export const getAllDistrict = createAsyncThunk("district/getAllDistrict", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllDistrict();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("district/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("district/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("district/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageDistrict({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create district
export const createDistrict = createAsyncThunk("district/createDistrict", async (param, { rejectWithValue }) => {
  const { province, name, districtId, isActive } = param;
  try {
    const body = JSON.stringify({ province, name, districtId, isActive });
    const { data } = await API.createDistrict(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateDistrict = createAsyncThunk("district/updateDistrict", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { province, name, districtId, isActive } = values;
  try {
    const body = JSON.stringify({ province, name, districtId, isActive });
    const { data } = await API.updateDistrict(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("district/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage } = param;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
